import { IconInputEye, IconInputEyeCrossed } from '@fabric-app/icons/old';
import { AuthTextInput } from '@fabric-app/ui/components/TextInput/TextInput';
import { useState } from 'react';
import { styled } from 'styled-components';

export const AuthPasswordTextInput = styled(AuthTextInput).attrs((p) => {
  const [showPassword, setShowPassword] = useState(false);
  return {
    endAdornment: (
      <SwitchButton type="button" tabIndex={-1} onClick={() => setShowPassword(!showPassword)}>
        {showPassword ? <IconInputEyeCrossed /> : <IconInputEye />}
      </SwitchButton>
    ),
    type: showPassword ? 'text' : 'password',
    name: 'password',
    placeholder: 'Password',
    ...p,
  };
})``;

const SwitchButton = styled.button`
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
`;
